import Image from 'next/image';
import { Box, Typography } from '@mui/material';

import theme from 'src/style-system/theme';
import CuminButton from '@components/Button';

import { useStyles } from './useStyles';

interface INewsSectionComponent {
  slice: any;
}

const NewsSectionComponent = ({ slice }: INewsSectionComponent) => {
  const { items, primary } = slice || {};

  const classes = useStyles();

  return (
    <Box className={classes.mainContainer}>
      <Typography variant="body1" align="center" color="cumin.main">
        For press inquiries, contact{' '}
        <a
          href="mailto:ragoth@thecuminclub.com"
          style={{
            color: theme.palette.garamMasala.main,
            textDecoration: 'underline',
          }}
        >
          ragoth@thecuminclub.com
        </a>
      </Typography>
      <Typography
        variant="h2"
        align="center"
        color="garamMasala.main"
        m="50px 0"
      >
        {primary?.title}
      </Typography>
      <Box className={classes.container}>
        <Box className={classes.itemWrapper}>
          {items.map((item: any) => {
            const { image, ctalink, description } = item || {};
            return (
              <Box className={classes.item}>
                <Typography
                  variant="body2"
                  align="center"
                  color="garamMasala.main"
                >
                  {item.description}
                </Typography>
                <Box className={classes.imgWrapper}>
                  {image?.url ? (
                    <Image
                      src={image?.url}
                      alt={image?.alt || 'Logo'}
                      objectFit="contain"
                      layout="fill"
                    />
                  ) : null}
                </Box>
                <a href={ctalink?.url} target="_blank">
                  <CuminButton
                    variant="contained"
                    color="cinnamon"
                    borderRadius="24"
                    textColor="whitePepper.main"
                    width="175px"
                    height="50"
                    //onClick={() =>}
                    //className={classes.btn}
                  >
                    Read More
                  </CuminButton>
                </a>
              </Box>
            );
          })}
        </Box>
      </Box>
    </Box>
  );
};

export default NewsSectionComponent;
